import React, { memo } from 'react';
import { LoanService } from '../../services';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MoneyOffIcon from '@material-ui/icons/MoneyOff';


const AddMarkAsNotFundingButton = ({selectedRowIndices, records}) => {
    const loanNumbers = selectedRowIndices.map(rowId => records[rowId].loanNumber)
    const handleClick = () => {
        LoanService.markLoansAsNotFunding(loanNumbers).then(response => {
          // !FIXME: Do this better!
          window.location.reload();
        });
    }

  return (
      <Tooltip title={`Mark as 'Not Funding'`}>
          <IconButton onClick={handleClick}>
              <MoneyOffIcon />
          </IconButton>
      </Tooltip>
  );
}

export default memo(AddMarkAsNotFundingButton);
